import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export const JobNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <PageHeader title={t("jobs.notFound.title", "Job Offer Not Found")} />
      <div className="mb-6">
        <Link to="/jobs" className="text-digger-blue hover:underline flex items-center">
          <ArrowLeft className="h-4 w-4 mr-1" />
          {t("jobs.notFound.back", "Back to job offers")}
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <p className="text-gray-600 mb-4">{t("jobs.notFound.message", "The job offer you're looking for doesn't exist or couldn't be loaded.")}</p>
        <Link to="/jobs">
          <Button>{t("jobs.notFound.viewAll", "View All Job Offers")}</Button>
        </Link>
      </div>
    </div>
  );
};
